import {
  FETCH_SESSIONS,
  CREATE_SESSION,
  CLEAN_SESSION,
  FETCH_SESSION,
  ADD_INGREDIENT,
  DELETE_INGREDIENT,
  UPDATE_INGREDIENT,
  ADD_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  UPDATE_PROD_SESSION,
  UPDATE_LEFTOVER,
  FETCH_SESSION_OUTPUT,
  FETCH_SESSION_DETAIL,
  UPDATE_SESSION,
  FETCH_SESSION_CAN_PRODUCE,
  FETCH_RECIPES,
  CREATE_INTERMEDIATE_LABELS,
  FETCH_STATIONS,
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_SESSIONS
// --------------------------------------------------------------------------
export const fetchSessions = (page, id, date, station) => ({
  type: FETCH_SESSIONS.init,
  payload: API.fetchSessions(page, id, date, station),
});

export const fetchSessionsSuccess = (info) => ({
  type: FETCH_SESSIONS.success,
  payload: info,
});

export const fetchSessionsFailure = (error) => ({
  type: FETCH_SESSIONS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_SESSION
// --------------------------------------------------------------------------
export const createSession = (data) => ({
  type: CREATE_SESSION.init,
  payload: API.createSession(data),
});

export const createSessionSuccess = (info) => ({
  type: CREATE_SESSION.success,
  payload: info,
});

export const createSessionFailure = (error) => ({
  type: CREATE_SESSION.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CLEAN_SESSION
// --------------------------------------------------------------------------
export const cleanSession = () => ({
  type: CLEAN_SESSION,
});

// --------------------------------------------------------------------------
// FETCH_SESSION
// --------------------------------------------------------------------------
export const fetchSession = (sId) => ({
  type: FETCH_SESSION.init,
  payload: API.fetchSession(sId),
});

export const fetchSessionSuccess = (info) => ({
  type: FETCH_SESSION.success,
  payload: info,
});

export const fetchSessionFailure = (error) => ({
  type: FETCH_SESSION.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// ADD_INGREDIENT
// --------------------------------------------------------------------------
export const addIngredient = (psId, code, format) => ({
  type: ADD_INGREDIENT.init,
  payload: API.addIngredient(psId, code, format),
});

export const addIngredientSuccess = (data) => ({
  type: ADD_INGREDIENT.success,
  payload: data,
});

export const addIngredientFailure = (error) => ({
  type: ADD_INGREDIENT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// DELETE_INGREDIENT
// --------------------------------------------------------------------------
export const deleteIngredient = (psId, info_id) => ({
  type: DELETE_INGREDIENT.init,
  payload: API.deleteIngredient(psId, info_id),
});

export const deleteIngredientSuccess = (data) => ({
  type: DELETE_INGREDIENT.success,
  payload: data,
});

export const deleteIngredientFailure = (error) => ({
  type: DELETE_INGREDIENT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UPDATE_INGREDIENT
// --------------------------------------------------------------------------
export const updateIngredient = (psId, invId, amount) => ({
  type: UPDATE_INGREDIENT.init,
  payload: API.updateIngredient(psId, invId, amount),
});

export const updateIngredientSuccess = (data) => ({
  type: UPDATE_INGREDIENT.success,
  payload: data,
});

export const updateIngredientFailure = (error) => ({
  type: UPDATE_INGREDIENT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// ADD_PRODUCT
// --------------------------------------------------------------------------
export const addProduct = (psId, itemId, amount, pieces, times) => ({
  type: ADD_PRODUCT.init,
  payload: API.addProduct(psId, itemId, amount, pieces, times),
});

export const addProductSuccess = (data) => ({
  type: ADD_PRODUCT.success,
  payload: data,
});

export const addProductFailure = (error) => ({
  type: ADD_PRODUCT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// DELETE_PRODUCT
// --------------------------------------------------------------------------
export const deleteProduct = (psId, info_id) => ({
  type: DELETE_PRODUCT.init,
  payload: API.deleteProduct(psId, info_id),
});

export const deleteProductSuccess = (data) => ({
  type: DELETE_PRODUCT.success,
  payload: data,
});

export const deleteProductFailure = (error) => ({
  type: DELETE_PRODUCT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UPDATE_PRODUCT
// --------------------------------------------------------------------------
export const updateProduct = (psId, itemId, amount, pieces) => ({
  type: UPDATE_PRODUCT.init,
  payload: API.updateProduct(psId, itemId, amount, pieces),
});

export const updateProductSuccess = (data) => ({
  type: UPDATE_PRODUCT.success,
  payload: data,
});

export const updateProductFailure = (error) => ({
  type: UPDATE_PRODUCT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UPDATE_LEFTOVER
// --------------------------------------------------------------------------
export const updateLeftover = (psId, itemId, hasLeftover, amount) => ({
  type: UPDATE_LEFTOVER.init,
  payload: API.updateLeftover(psId, itemId, hasLeftover, amount),
});

export const updateLeftoverSuccess = (data) => ({
  type: UPDATE_LEFTOVER.success,
  payload: data,
});

export const updateLeftoverFailure = (error) => ({
  type: UPDATE_LEFTOVER.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UPDATE_PROD_SESSION
// --------------------------------------------------------------------------
export const updateProdSession = (sId, data) => ({
  type: UPDATE_PROD_SESSION.init,
  payload: API.updateProdSession(sId, data),
});

export const updateProdSessionSuccess = (data) => ({
  type: UPDATE_PROD_SESSION.success,
  payload: data,
});

export const updateProdSessionFailure = (error) => ({
  type: UPDATE_PROD_SESSION.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_RECIPES
// --------------------------------------------------------------------------
export const fetchRecipes = (filter) => ({
  type: FETCH_RECIPES.init,
  payload: API.fetchRecipes(filter),
});

export const fetchRecipesSuccess = (data) => ({
  type: FETCH_RECIPES.success,
  payload: data,
});

export const fetchRecipesFailure = (error) => ({
  type: FETCH_RECIPES.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_INTERMEDIATE_LABELS
// --------------------------------------------------------------------------
export const createIntermediateLabels = (productionSessionId, data) => ({
  type: CREATE_INTERMEDIATE_LABELS.init,
  payload: API.createIntermediateLabels(productionSessionId, data),
});

export const createIntermediateLabelsSuccess = (info) => ({
  type: CREATE_INTERMEDIATE_LABELS.success,
  payload: info,
});

export const createIntermediateLabelsFailure = (error) => ({
  type: CREATE_INTERMEDIATE_LABELS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_SESSION_OUTPUT
// --------------------------------------------------------------------------
export const fetchSessionOutput = (sId) => ({
  type: FETCH_SESSION_OUTPUT.init,
  payload: API.fetchSessionOutput(sId),
});

export const fetchSessionOutputSuccess = (info) => ({
  type: FETCH_SESSION_OUTPUT.success,
  payload: info,
});

export const fetchSessionOutputFailure = (error) => ({
  type: FETCH_SESSION_OUTPUT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_SESSION_DETAIL
// --------------------------------------------------------------------------
export const fetchSessionDetail = (sId) => ({
  type: FETCH_SESSION_DETAIL.init,
  payload: API.fetchSessionDetail(sId),
});

export const fetchSessionDetailSuccess = (info) => ({
  type: FETCH_SESSION_DETAIL.success,
  payload: info,
});

export const fetchSessionDetailFailure = (error) => ({
  type: FETCH_SESSION_DETAIL.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// UPDATE_SESSION
// --------------------------------------------------------------------------
export const updateSession = (id, data) => ({
  type: UPDATE_SESSION.init,
  payload: API.updateSession(id, data),
});

export const updateSessionSuccess = (info) => ({
  type: UPDATE_SESSION.success,
  payload: info,
});

export const updateSessionFailure = (error) => ({
  type: UPDATE_SESSION.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_SESSION_CAN_PRODUCE
// --------------------------------------------------------------------------
export const fetchSessionCanProduce = (sId) => ({
  type: FETCH_SESSION_CAN_PRODUCE.init,
  payload: API.fetchSessionCanProduce(sId),
});

export const fetchSessionCanProduceSuccess = (info) => ({
  type: FETCH_SESSION_CAN_PRODUCE.success,
  payload: info,
});

export const fetchSessionCanProduceFailure = (error) => ({
  type: FETCH_SESSION_CAN_PRODUCE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_STATIONS
// --------------------------------------------------------------------------
export const fetchStations = () => ({
  type: FETCH_STATIONS.init,
  payload: API.fetchStations(),
});

export const fetchStationsSuccess = (info) => ({
  type: FETCH_STATIONS.success,
  payload: info,
});

export const fetchStationsFailure = (error) => ({
  type: FETCH_STATIONS.failure,
  payload: error,
});
